export interface SneakerReleaseAtom {
    type: ReleaseType;
    brand: BrandReleaseProduct | undefined;
}

export interface SneakLaunchResponse {
    getReleaseProducts: {
        items: SneakLaunch[];
        totalCount: number;
        totalPages: number;
        pageInfo: {
            page: number;
            pageSize: number;
        };
    };
}

export interface BrandReleaseProductResponse {
    getBrandReleaseProducts: {
        items: BrandReleaseProduct[];
    };
}

export interface BrandReleaseProduct {
    brand?: string;
    brandCode?: string;
}

export interface SneakLaunch {
    id: number;
    title: string;
    releaseDate: string;
    publishDate: string;
    pageTheme: string;
    color: string;
    styleCode: string;
    retail: string;
    thumbnail: Thumbnail;
    images: Image[];
    brand: string;
    brandCode: string;
    htmlContent: string;
    slug: string;
    tags: string;
    model: {
        title: string;
        slug: string;
    };
}

interface Image {
    path: string;
    accessId: string;
}

interface Thumbnail {
    root?: string;
    thumbnail?: string;
}

export enum ReleaseType {
    Upcoming = 'upcoming',
    Dropped = 'dropped'
}
